





























































































































import genres from '../data/genres';
import Vue, {PropType} from 'vue';
import Project from '@/types/Project';
import {ProjectInfoState} from '@/components/types/ProjectInfoState';
import compilerVersions from '../emulatorVersions';

export default Vue.extend({
    props: {
        state: { type: String as PropType<ProjectInfoState>, required: true },
        username: { type: String, required: true },
        project: { type: Object as PropType<Project>, required: true },
        buttonText: { type: String, required: true },
        deleteButtonText: { type: String },
        upgradeButtonText: { type: String },
        error: { type: String },
    },

    data() {
        return { genres };
    },

    methods: {
        handleSubmit() {
            this.$emit('submit', this.project);
        },

        upgradeable() {
            console.log(this.project.archVersion);
            return this.upgradeButtonText && (this.project.archVersion !== compilerVersions[0]);
        },
    },
});
